import errors from './errors/index.js';
import translation from './translation/index.js';
const zh_cn = {
    translation,
    errors,
};
export default Object.freeze(zh_cn);
